export const SET_USER_INFO = 'SET_USER_INFO'

export const SET_SHOP_CAR = 'SET_SHOP_CAR'

export const SET_SWIPER_LIST = 'SET_SWIPER_LIST'

export const IS_SEND_CODE = 'IS_SEND_CODE'

export const SEARCH_TEXT = 'SEARCH_TEXT'

export const SHOP_CAR_COUNT = 'SHOP_CAR_COUNT'

export const SHOW_LOGIN = 'SHOW_LOGIN'



// WEBPACK FOOTER //
// ./src/store/mutationTypes.js